import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginForm from './components/LoginForm';
import TwoFactorAuth from './components/TwoFactorAuth';
import { isSessionValid, clearSession } from '../../services/localStorage';

const LoginAndAuthentication = () => {
  const navigate = useNavigate();
  const [show2FA, setShow2FA] = useState(false);

  useEffect(() => {
    // Check if user is already logged in with valid session
    if (isSessionValid()) {
      navigate('/dashboard-overview');
      return;
    } else {
      // Clear any expired/invalid session
      clearSession();
    }

    // Set page title
    document.title = 'Iniciar Sesión - VIN Pro Platform';
  }, [navigate]);

  const handleToggle2FA = () => {
    setShow2FA(!show2FA);
  };

  return (
    <div className="min-h-screen bg-background">
      {/* Main Content */}
      <div className="flex flex-col items-center justify-center min-h-screen px-4 py-8">
        <div className="w-full max-w-6xl mx-auto">
          {/* Login/2FA Form */}
          <div className="flex justify-center">
            {show2FA ? (
              <TwoFactorAuth onToggle2FA={handleToggle2FA} />
            ) : (
              <LoginForm onToggle2FA={handleToggle2FA} show2FA={show2FA} />
            )}
          </div>
        </div>
      </div>
      {/* Footer */}
      <footer className="bg-card border-t border-border py-6">
        <div className="max-w-6xl mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <div className="text-center md:text-left">
              <p className="text-sm text-muted-foreground">
                © {new Date()?.getFullYear()} VIN Pro Platform. Todos los derechos reservados.
              </p>
              <p className="text-xs text-muted-foreground mt-1">
                Plataforma especializada para profesionales automotrices en México
              </p>
            </div>
            
            <div className="flex items-center space-x-6 text-xs text-muted-foreground">
              <a href="#" className="hover:text-foreground transition-smooth">
                Términos de Servicio
              </a>
              <a href="#" className="hover:text-foreground transition-smooth">
                Política de Privacidad
              </a>
              <a href="#" className="hover:text-foreground transition-smooth">
                Soporte Técnico
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LoginAndAuthentication;